'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';
import { useNotifications } from '@/contexts/NotificationContext';

interface Props {
  onMenuClick: () => void;
}

export default function CustomerDashboardTopbar({ onMenuClick }: Props) {
  const { unreadCount } = useNotifications();

  return (
    <header className="sticky top-0 z-10 bg-card border-b border-border px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
          aria-label="Open menu"
        >
          <Icon name="Bars3Icon" size={20} />
        </button>
        <h1 className="text-base font-600 text-foreground hidden sm:block">My Account</h1>
      </div>
      <div className="flex items-center gap-3">
        {/* Notification bell with live badge */}
        <Link
          href="/customer-dashboard/notifications"
          className="relative p-2 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
          aria-label="Notifications"
        >
          <Icon name="BellIcon" size={20} />
          {unreadCount > 0 ? (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-700 rounded-full flex items-center justify-center px-1 border-2 border-card leading-none">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          ) : (
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-warning rounded-full border-2 border-card" />
          )}
        </Link>
        <Link
          href="/customer-dashboard/support"
          className="p-2 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
          aria-label="Support"
        >
          <Icon name="ChatBubbleLeftRightIcon" size={20} />
        </Link>
        <Link
          href="/customer-dashboard/profile"
          className="p-2 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
          aria-label="Profile"
        >
          <Icon name="UserCircleIcon" size={20} />
        </Link>
      </div>
    </header>
  );
}
